import { getHiDpiRatio } from '../../../../render-settings';
import { ThumbnailRequest } from '../requests-queue/ThumbnailRequest.js';

const MAX_BG_SIZE = 2000;

export class BackgroundLayer {
  constructor (viewport, requestQueue) {
    this.viewport = viewport;
    this.requestQueue = requestQueue;
  }

  attachRenderer (renderer) {
    // create the sprite that will render this image
    this.sprite = renderer.createSprite();
  }

  init () {
    // store off the max possible zoom
    this.maxZoom = this.viewport.getMaxZoom() * getHiDpiRatio();

    // compute the scale of the image we're downloading relative to the size of the overall image
    const { h, w } = this.viewport.getImageDims();
    this.bgScale = Math.max(w, h) / MAX_BG_SIZE; // note: can request thumbnail larger than image. Is this an issue?

    // Compute the dimensions of the background image to request from image server.
    const bgWidth = w / this.bgScale;
    const bgHeight = h / this.bgScale;

    // Request the background image.
    const request = new ThumbnailRequest(bgWidth, bgHeight);
    request.onTextureLoaded = (response) => this.onTextureLoaded(response);
    this.requestQueue.enqueue(request);
  }

  onTextureLoaded (response) {
    return this.sprite.loadTexture(response);
  }

  update ({ zoom }) {
    this.sprite.setScale(this.maxZoom / zoom * this.bgScale);
  }

  draw (camera) {
    this.sprite.draw(camera);
  }
}
